import { compareVersions } from '@/utils/InputProcessingUtilities';
import {
  showPortalOutdatedNotification,
  showWarningNotification,
} from '@/helpers/notifiers';
import { sendWarning } from '@/helpers/sentry';
import { getVersion } from '@/api';

export default function fetchPortalVersionInterval(): void {
  // portal version check timer
  const portalVersionInterval = setInterval(
    () => {
      // getting version from the file from the server
      getVersion()
        .then((res) => {
          const compareAppVersionsResult = compareVersions(
            res,
            __APP_VERSION__ || '1.0.0',
          );
          // reloading the page if current version (from the .env file) is smaller
          // than version from the file from the server
          if (compareAppVersionsResult >= 1) {
            // showing notification
            showWarningNotification({
              title: 'The portal version is outdated',
              text: 'The page will be reloaded in 5 seconds',
            });
            // reloading page after 5 seconds
            setTimeout(() => {
              window.location.reload();
            }, 5000);
          }
        })
        .catch((error: unknown) => {
          // On error:
          // sending the warning to Sentry
          sendWarning(error, 'Get portal version error');
          // clearing interval
          clearInterval(portalVersionInterval);
          // notification for user
          showPortalOutdatedNotification();
        });
    },
    60 * 60 * 1000,
  ); // one hour
}
